﻿export enum ClientCode {
    Undefined = 0,
    LAG = 1,
    GTN = 2
}